import { render, staticRenderFns } from "./DemoDialog.vue?vue&type=template&id=750b689e&scoped=true"
import script from "./DemoDialog.vue?vue&type=script&lang=ts"
export * from "./DemoDialog.vue?vue&type=script&lang=ts"
import style0 from "./DemoDialog.vue?vue&type=style&index=0&id=750b689e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750b689e",
  null
  
)

export default component.exports